// ============================================================================
// page-projects / services-carousel.js
// ----------------------------------------------------------------------------
// "EXPLORE Our Services" — left-aligned Flickity carousel near the bottom of
// the page. External prev/next buttons sit above the strip.
//
//   .projects-services__card                Flickity container.
//   .projects-services__nav-button.prev     Previous button.
//   .projects-services__nav-button.next     Next button.
// ============================================================================

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".projects-services__card");
  if (!sliderEl) return;

  // Original inline code set display:block before Flickity init; keep the
  // side effect for layout parity.
  sliderEl.style.display = "block";

  const instances = initCarousels(".projects-services__card", {
    cellAlign: "left",
    contain: true,
    pageDots: false,
  });

  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  const prev = document.querySelector(".projects-services__nav-button.prev");
  const next = document.querySelector(".projects-services__nav-button.next");

  if (prev) {
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  }
  if (next) {
    next.addEventListener("click", function () {
      flkty.next();
    });
  }
});
